import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import {
  UpdateUserLanguageMutation,
  UpdateUserLanguageMutationVariables,
} from '../../../data-access/gql-types/graphql';
import { UPDATE_USER_LANGUAGE } from '../../../data-access/mutations/user';
import { useSetAppLocale } from '../../../hooks/native/use-app-locales';
import { useUserProfileStore } from '../../../store/user-profile';
import { prepareLanguageForRequest } from '../../../utils/translations/sub-languages';

export const useSetLanguage = () => {
  const { i18n } = useTranslation('common');
  const { setAppLocale } = useSetAppLocale();
  const [updateLanguage] = useMutation<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(
    UPDATE_USER_LANGUAGE,
  );
  const { profileData } = useUserProfileStore((s) => s);

  useEffect(() => {
    if (profileData?.userLanguage !== undefined) {
      if (profileData?.userLanguage === '') {
        const lang = prepareLanguageForRequest(i18n.language);

        updateLanguage({
          variables: {
            input: {
              language: lang,
            },
          },
          onCompleted: (data) => {
            if (data?.updateUserLanguage) {
              setAppLocale(lang);
            }
          },
        });
      } else {
        const lang = profileData.userLanguage;
        i18n.changeLanguage(lang);
        setAppLocale(lang);
      }
    }
  }, [profileData?.userLanguage]);
};
